//
import { mapActions, mapState } from 'vuex'
import { ModelDataTable } from '@/components/reusable_components/next'

//
import GErrorModel from '@/models/General/GError'
import PosSaleToListModel from '@/models/POS/PosSaleToList'
import PosSaleService from '@/services/api/pos/pos-sale'
import filters from './filters'
import headers from './headers'

//
export default {
	name: 'pos-sale-list',
	components: {
		'crud-data-table': ModelDataTable,
	},
	computed: {
		//
		...mapState('AuthModule', ['user']),
		/**
		 *
		 */
		tableProps() {
			return {
				service: PosSaleToListModel,
				paramFilter: {
					inventory_editable: '1',
				},
				filters: filters({
					g_branch_office_address: this.user.hr_employee
						.g_branch_office.address,
				}),
				headers,
			}
		},
	},
	data: () => ({
		busy: {
			related: false,
		},
		dialogs: {
			related: false,
		},
		pchPurchaseOrderNumber: '',
		posSale: null,
	}),
	methods: {
		//
		...mapActions('MenuesModule', {
			setTitleTopBar: 'setTitleTopBar',
		}),

		/**
		 * 
		 */
		failModify(error) {
			this.showErrorSnackbar(GErrorModel.from(error).getError())
		},

		/**
		 * 
		 */
		readyModify() {
			this.showSuccessSnackbar('Orden de compra asociada exitosamente.')
			this.dialogs.related = false
			this.$refs.table.refresh()
		},

		/**
		 * 
		 */
		async submitRelated(event) {

			// require
			let posSale = this.posSale
			let posSalePurchaseOrder = this.pchPurchaseOrderNumber || ''

			//
			this.busy.related = true
			await PosSaleService.modifyPurchaseOrder(posSale, posSalePurchaseOrder).then(this.readyModify).catch(this.failModify)
			this.busy.related = false
		},

		/**
		 *
		 */
		submitUpdate(event) {
			this.$router.push({
				name: 'pos-sale-update',
				params: { id: event.item.id },
			})
		},
	},
	beforeMount() {
		this.setTitleTopBar('Tickets de venta')
	},
	beforeRouteEnter(to, from, next) {
		next(ctx => {
			if (!ctx.$can('VIEW_ALL_SALE_TICKET')) ctx.$router.push('/')
		})
	},
}
